var map = {
	"./Blog": 2824,
	"./Blog.vue": 2824,
	"./Careers": 3493,
	"./Careers.vue": 3493,
	"./CareersJob": 8444,
	"./CareersJob.vue": 8444,
	"./Challenge": 6878,
	"./Challenge.vue": 6878,
	"./Company": 1586,
	"./Company.vue": 1586,
	"./ContactSales": 2382,
	"./ContactSales.vue": 2382,
	"./CookiesPolicy": 5972,
	"./CookiesPolicy.vue": 5972,
	"./DemoExample/FaceDemoLayout": 5088,
	"./DemoExample/FaceDemoLayout.vue": 5088,
	"./DemoExample/FaceMatching": 9172,
	"./DemoExample/FaceMatching.vue": 9172,
	"./DemoExample/GalleryIdent": 2829,
	"./DemoExample/GalleryIdent.vue": 2829,
	"./DemoExample/KYC": 367,
	"./DemoExample/KYC.vue": 367,
	"./DemoExample/LivenessDetection": 2074,
	"./DemoExample/LivenessDetection.vue": 2074,
	"./DemoExample/ProcessImage": 8807,
	"./DemoExample/ProcessImage.vue": 8807,
	"./EbookPage": 7860,
	"./EbookPage.vue": 7860,
	"./Ebooks": 5932,
	"./Ebooks.vue": 5932,
	"./EmailPasswordReset": 1972,
	"./EmailPasswordReset.vue": 1972,
	"./Error": 8505,
	"./Error.vue": 8505,
	"./Faqs": 80,
	"./Faqs.vue": 80,
	"./GeneralInformationSecurityPolicy": 2043,
	"./GeneralInformationSecurityPolicy.vue": 2043,
	"./Home": 2150,
	"./Home.vue": 2150,
	"./JobApplicantPrivacyPolicy": 7651,
	"./JobApplicantPrivacyPolicy.vue": 7651,
	"./Login": 2710,
	"./Login.vue": 2710,
	"./PostPage": 1219,
	"./PostPage.vue": 1219,
	"./Press": 6422,
	"./Press.vue": 6422,
	"./Pricing": 7983,
	"./Pricing.vue": 7983,
	"./PrivacyPolicy": 7742,
	"./PrivacyPolicy.vue": 7742,
	"./Products/YouAuth": 9382,
	"./Products/YouAuth.vue": 9382,
	"./Products/YouFace": 1895,
	"./Products/YouFace.vue": 1895,
	"./Products/YouID": 2602,
	"./Products/YouID.vue": 2602,
	"./Projects": 6467,
	"./Projects.vue": 6467,
	"./Register": 842,
	"./Register.vue": 842,
	"./ResetPassword": 1623,
	"./ResetPassword.vue": 1623,
	"./ResponsibleDisclosureProgram": 7434,
	"./ResponsibleDisclosureProgram.vue": 7434,
	"./RoiCalculator": 2918,
	"./RoiCalculator.vue": 2918,
	"./RoiCalculatorV2": 8988,
	"./RoiCalculatorV2.vue": 8988,
	"./TermsConditions": 338,
	"./TermsConditions.vue": 338,
	"./UseCases/Banking": 2535,
	"./UseCases/Banking.vue": 2535,
	"./UseCases/Hospitality": 8157,
	"./UseCases/Hospitality.vue": 8157,
	"./UseCases/Igaming": 1225,
	"./UseCases/Igaming.vue": 1225,
	"./UseCases/Mobility": 7497,
	"./UseCases/Mobility.vue": 7497,
	"./User/APIAccess": 7541,
	"./User/APIAccess.vue": 7541,
	"./User/AccountSettings": 1346,
	"./User/AccountSettings.vue": 1346,
	"./User/BillingAddress": 5708,
	"./User/BillingAddress.vue": 5708,
	"./User/Branding": 9371,
	"./User/Branding.vue": 9371,
	"./User/Dashboard": 2025,
	"./User/Dashboard.vue": 2025,
	"./User/Invoices": 7137,
	"./User/Invoices.vue": 7137,
	"./User/Plans": 8316,
	"./User/Plans.vue": 8316,
	"./User/Statistics": 8114,
	"./User/Statistics.vue": 8114,
	"./User/Subscription": 1684,
	"./User/Subscription.vue": 1684,
	"./Videos": 9896,
	"./Videos.vue": 9896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;